import { BarChart3,Brain,
  Zap,
  Files,
  Users,
  Settings,
  Database,
  Home,
  GitGraph,
  TrendingUp,
  CloudUploadIcon,
  DatabaseBackup,
  ScrollText,
  ClipboardList,
  CheckSquare,
  AlertTriangle} from "lucide-react"
import { chartExtractionRuns } from "./chartExtractionMockData";
import { endOfDay, startOfDay, subDays } from "date-fns";
// import {demoLabels} from "./labels/demoLabels";
// const orgConfigDetails = demoLabels;
import demoLabels from './labels/demoLabels';
const activeOrg = import.meta.env.VITE_ORG  as keyof typeof demoLabels.org ||"kanTime";
const orgConfigDetails = demoLabels.org[activeOrg];

// import { vi } from "vitest";
// for side menu mapping object
export const viewList={
    dashboard:'dashboard',
    chartExtractionRuns:'chart-extraction-runs',
    chartReview:'chat-harvest',
    aiPromptManager:'ai-prompt-manager',
    turfAIStudio:'turf-ai-studio',
    batchFiles:'batch-file-manager',
    settings:'settings',
    userManagement:'user-management',
    llmModel:'llm-model',
    system:'System',
    main:'Main',
    admin:'Admin',
    kanTimeDetails:'kanTime-details',
    backUpManagement:'backUp-management',
    auditLogs:'audit-logs',
    clinicianView:'client-clinician-view',
    renewalTasks:'renewal-tasks',
    supervisorDashboard:'supervisor-dashboard',
    supervisorRiskView:'supervisor-risk-view',
    workflowRunLogs:'workflow-run-logs',

}
// list should show in dashboard based on response 
export const menuConfig = (viewList: any) => ({
  "Dashboard": {
    icon: Home,
    view: viewList.dashboard,
    section: "Main"
  },
  "Chart Extraction Details":{
    icon: TrendingUp,
    view: viewList.chartExtractionRuns,
    section: "Main"

  },
  "Chart Review": {
    icon: BarChart3,
    view: viewList.chartReview,
    section: "Main"
  },
  "Prompts": {
    icon: Brain,
    view: viewList.aiPromptManager,
    section: "Main"
  },
   "Kantime Status": {
    icon: CloudUploadIcon,
    view: viewList.kanTimeDetails,
    section: "Main"
  },
   "System Status": {
    icon: CloudUploadIcon,
    view: viewList.kanTimeDetails,
    section: "Main"
  },
  "Backup History": {
    icon: DatabaseBackup,
    view: viewList.backUpManagement,
    section: "Admin"
  },
  "Turf AI Studio": {
    icon: Zap,
    view: viewList.turfAIStudio,
    section: "Main"
  },
  "Batch Files": {
    icon: Files,
    view: viewList.batchFiles,
    section: "Main"
  },
  "Activity Logs": {
    icon: ScrollText,
    view: viewList.auditLogs,
    section: "Admin"
  },
  "Workflow Run Logs": {
    icon: GitGraph,
    view: viewList.workflowRunLogs,
    section: "Admin"
  },
   "Client Overview": {
    icon: ClipboardList,
    view: viewList.clinicianView,
    section: "Main"
  },
  "Compliance Renewals": {
    icon: CheckSquare,
    view: viewList.renewalTasks,
    section: "Main",
    hasSubMenu: true,
    isExpanded: false,
    subMenu: [
      {
        id: viewList.renewalTasks,
        icon: CheckSquare,
        label: "My Tasks",
        view: viewList.renewalTasks,
        isActive: false
      },
      {
        id: viewList.supervisorDashboard,
        icon: AlertTriangle,
        label: "Supervisor Dashboard",
        view: viewList.supervisorDashboard,
        isActive: false
      },
    ],
  },
  "User Management": {
    icon: Users,
    view: viewList.userManagement,
    section: "Admin"
  },
  "Settings": {
    icon: Settings,
    view: viewList.settings,
    section: "Admin",
    // hasSubMenu: true,
    // isExpanded:viewList.settings===viewList.settings,
    // subMenu: [
    //   {
    //     id: viewList.llmModel,
    //     icon: Database,
    //     label: "System",
    //     view: viewList.settings,
    //     isActive: viewList.llmMode
    //   },
    // ],
  },
});

// Do NOT change the output structure - only adapt for optimized rendering
// export const mapSideMenu = (
//   navigator: Array<{ name: string }>,
//   currentView: string,
//   expandedIds: string[] = [],
//   viewList: any
// ) => {
//   const config = menuConfig(viewList);

//   return navigator
//     ?.map(item => {
//       const menu = config[item.name];
//       if (!menu) return null;
//       const id = menu.view || item.name; // fallback for unique key
//       const isExpanded = expandedIds.includes(id);
//       return {
//         id,
//         name: item.name,
//         icon: menu.icon,
//         label: item.name,
//         view: menu.view,
//         isActive: currentView === menu.view,
//         section: menu.section,
//         hasSubMenu: !!menu.hasSubMenu,
//         isExpanded,
//         subMenu: menu.subMenu?.map(sub => ({
//           id: sub.view,
//           icon: sub.icon,
//           label: sub.label,
//           view: sub.view,
//           isActive: currentView === sub.view,
//         })),
//       };
//     })
//     .filter(Boolean);
// };
export const mapSideMenu = (
  navigator: Array<{ name: string; userPermissions: string[]; subRoutes?: any[] }>, 
  currentView: string
) => {
  const config = menuConfig(viewList);

  return navigator
    ?.map((item) => {
      const menu = config[item.name];
      if (!menu) return null;

      const allPermissions = [
        ...(item?.userPermissions || []),
        ...(item?.subRoutes?.flatMap((sub) => sub.userPermissions || []) || [])
      ];

      return {
        id: menu.view,
        name: item.name,
        icon: menu.icon,
        label: item.name,
        view: menu.view,
        isActive: currentView === menu.view,
        section: menu.section,
        isExpandes: menu.isExpanded || false,
        hasSubmenu: menu.hasSubMenu || false,
        submenu: menu.subMenu?.map((sub) => ({
          icon: sub.icon,
          label: sub.label,
          view: sub.view,
          id: sub.id,
          isActive: true,
          userPermissions: allPermissions,
        })),
        userPermissions: allPermissions,
      };
    })
    .filter(Boolean); 
};

// to get query params
export const buildQuery = (filters:any, mapping = {}) => {
  const mappedFilters = {};

  for (const key in filters) {
    // if mapping[key] === null → skip this filter
    if (mapping[key] === null) continue;

    const paramName = mapping[key] || key; // use mapping if available
    const value = filters[key];

    if (value !== undefined && value !== null && value !== "") {
      mappedFilters[paramName] = Array.isArray(value)
        ? value.join(",") // join arrays with comma
        : value;
    }
  }

  return new URLSearchParams(mappedFilters).toString();
};
  export const flattenFilters = (filters: any) => {
  const flat: any = { ...filters };

  if (filters.dateRange?.from && filters.dateRange?.to) {
 const formatDate = (date: Date) =>
    date.toLocaleDateString("en-CA"); // YYYY-MM-DD

  flat.from = formatDate(filters.dateRange.from);
  flat.to   = formatDate(filters.dateRange.to);
  }

  delete flat.dateRange; // remove nested object
  return flat;
 
};
 export const getLastWeekRange = () => {
   const today = new Date();
 
   // Find previous week's Monday
   const dayOfWeek = today.getDay(); // 0 = Sunday, 1 = Monday
   const diffToLastMonday = dayOfWeek === 0 ? 13 : dayOfWeek + 6; 
   const lastMonday = subDays(today, diffToLastMonday);
 
   // Find previous week's Sunday
   const lastSunday = subDays(lastMonday, -6); // 6 days after Monday
   return {
     from: startOfDay(lastMonday),
     to: endOfDay(lastSunday),
   };
 };
//  to get 
 export function formatDate(date:any) {
    const pad = (n) => String(n).padStart(2, "0");
    return (
      date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1) +
      "-" +
      pad(date.getDate()) +
      " " +
      pad(date.getHours()) +
      ":" +
      pad(date.getMinutes()) +
      ":" +
      pad(date.getSeconds())
    );
  }
  // from custom calendar vaule to sql time to send BE
  export function toSQLDateTime(dateStr: string|Date): string {
  const d = new Date(dateStr);

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");

  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const seconds = String(d.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
// error handling 
export function errorResponse(err:any){
  if(err.status<500)
  {
    return err.message;
  }
  else{
    return "Something went wrong please try again"
  }
}
